import { createSlice } from "@reduxjs/toolkit";


const initialState={

}
export default createSlice({
    name:"mainSlice",
    initialState,
    reducers:{

    }
})


